const STORAGE_KEY = 'tick-studio:recents';
const MAX_RECENTS = 10;

export function loadRecents() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter((s) => typeof s === 'string') : [];
    } catch {
        return [];
    }
}

export function pushRecent(symbol) {
    if (!symbol) return;
    const prev = loadRecents().filter((s) => s !== symbol);
    const next = [symbol, ...prev].slice(0, MAX_RECENTS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
